/**
 * 用户 web api
 * @create 2025-06-06 15:16:22
 */
import request from "@/utils/request"
import service from "@/utils/service"

/**
 * 创建房间
 * @param param 查询参数
 */
export function appNewBridge(pk_user) {
  return request({
    url: service.tcode + "/tcode/api/bridge/appNewBridge/"+ pk_user,
    method: "get"
  })
}

/**
 * 查询房间信息
 * @param param 查询参数
 */
export function getMagpieBridgeBean(code) {
  return request({
    url: service.tcode + "/tcode/api/bridge/getMagpieBridgeBean/"+ code,
    method: "get"
  })
}

/**
 * 标识用上线
 * @param roleType, data 参数
 */
export function userIsOnline(roleType, data) {
  return request({
    url: service.tcode + "/tcode/api/bridge/onLine/"+ roleType,
    method: "post",
    data: data
  })
}
/**
 * 标识用离线
 * @param roleType,data: data 参数
 */
export function userIsOffline(roleType, data) {
  return request({
    url: service.tcode + "/tcode/api/bridge/offLine/"+ roleType,
    method: "post",
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/platform/bridge.js